import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";
import { localToday } from "../lib/format";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/routes",
  validateSearch: (search) => ({
    date: typeof search.date === "string" ? search.date : localToday(),
  }),
  beforeLoad: ({ context }) => {
    if (context.authLoading) return;
    if (!context.session) throw redirect({ to: "/auth/login" });
  },
  component: lazyRouteComponent(() => import("./routes"), "RouteBuilderPage"),
});
